export const actions = {
  async sendContact(...args) {
    const params = args[1];
    try {
      const { data } = await this.$axios.post('/contact/', params);
      if (data.error) {
        return {
          error: true,
          message: 'There was an error trying to submit form. Please try again later.'
        };
      }
      return {
        error: false,
        message: 'Submitted successfully'
      };
    } catch (e) {
      return {
        error: true,
        message: 'There was an error trying to submit form. Please try again later.'
      };
    }
  }
};
